<template>
  <a-modal v-model="modal" title="批量修改" width="500px" :maskClosable="false" :closable="false">
    <a-form-model :model="formData" ref="form">
      <a-form-model-item
        label="产能"
        :labelCol="{ style: 'width: 80px;float:left' }"
        :wrapperCol="{ style:'width:calc(100% - 80px ) !important;float:left'}"
        prop="capacitySufficientIs"
        :rules="rules.capacitySufficientIs"
        v-if="fieldType==='capacitySufficientIs'"
      >
        <a-select style="width: 100%;" v-model="formData.capacitySufficientIs" allowClear>
          <a-select-option v-for="(item) in capacitySufficientList" :key="item.lookupCode">{{ item.lookupValue }}</a-select-option>
        </a-select>
      </a-form-model-item>
      <a-form-model-item
        label="具体问题描述"
        :labelCol="{ style: 'width: 120px;float:left' }"
        :wrapperCol="{ style:'width:calc(100% - 120px ) !important;float:left'}"
        prop="specificProblemDescription"
        :rules="rules.specificProblemDescription"
        v-if="fieldType==='specificProblemDescription'"
      >
        <a-input type="text" :maxLength="50" v-model="formData.specificProblemDescription" />
      </a-form-model-item>
      <a-form-model-item
        label="产能解决方案"
        :labelCol="{ style: 'width: 120px;float:left' }"
        :wrapperCol="{ style:'width:calc(100% - 120px ) !important;float:left'}"
        prop="capacitySolutions"
        :rules="rules.capacitySolutions"
        v-if="fieldType==='capacitySolutions'"
      >
        <a-input type="text" :maxLength="50" v-model="formData.capacitySolutions" />
      </a-form-model-item>
      <a-form-model-item
        label="瓶颈物料"
        :labelCol="{ style: 'width: 95px;float:left' }"
        :wrapperCol="{ style:'width:calc(100% - 95px ) !important;float:left'}"
        prop="bottleneckMaterials"
        :rules="rules.bottleneckMaterials"
        v-if="fieldType==='bottleneckMaterials'"
      >
        <global-select
          class="select-material"
          v-model="formData.bottleneckMaterials"
          selectType="selectFilter"
          :focusGet="true"
          :dropdown-match-select-width="false"
          requestApi="/scp/scpMrpSystemItems/planItemsBox"
          :selectItem="{ value: 'selectedValue', label: 'label' }"
          :setParams="{ organizationCode: 'A001' }"
          searchParam="label"
          sourseField="res"
          :totalNum="9999999999"
          @change="(val) => changeBottleneckMaterial(val, formData)"
        />
      </a-form-model-item>
      <a-form-model-item
        label="压缩采购周期"
        :labelCol="{ style: 'width: 110px;float:left' }"
        :wrapperCol="{ style:'width:calc(100% - 110px ) !important;float:left'}"
        prop="compressPurchaseCycle"
        :rules="rules.compressPurchaseCycle"
        v-if="fieldType==='compressPurchaseCycle'"
      >
        <a-input-number
          style="width: 100%"
          class="num-input"
          :min="0"
          :max="9999999999"
          v-model="formData.compressPurchaseCycle"
          :formatter="value => `${value}`.replace(/^(\d*).*$/, '$1')"
          :parser="value => `${value}`.replace(/^(\d*).*$/, '$1')" />
      </a-form-model-item>
      <a-form-model-item
        label="已备料情况/物料解决方案"
        :labelCol="{ style: 'width: 180px;float:left' }"
        :wrapperCol="{ style:'width:calc(100% - 180px ) !important;float:left'}"
        prop="remark"
        :rules="rules.remark"
        v-if="fieldType==='remark'"
      >
        <a-input type="text" :maxLength="50" v-model="formData.remark" />
      </a-form-model-item>
      <a-form-model-item
        label="最晚确认时间"
        :labelCol="{ style: 'width: 120px;float:left' }"
        :wrapperCol="{ style:'width:calc(100% - 120px ) !important;float:left'}"
        prop="latestConfirmTime"
        :rules="rules.latestConfirmTime"
        v-if="fieldType==='latestConfirmTime'"
      >
        <a-date-picker v-model="formData.latestConfirmTime" valueFormat="YYYY-MM-DD" :disabled-date="disabledEndDate" />
      </a-form-model-item>
      <a-form-model-item
        label="备注(供应策略方案)"
        :labelCol="{ style: 'width: 150px;float:left' }"
        :wrapperCol="{ style:'width:calc(100% - 150px ) !important;float:left'}"
        prop="supplyStrategyProposal"
        :rules="rules.supplyStrategyProposal"
        v-if="fieldType==='supplyStrategyProposal'"
      >
        <a-input type="text" :maxLength="50" v-model="formData.supplyStrategyProposal" />
      </a-form-model-item>
    </a-form-model>
    <template #footer>
      <a-space>
        <a-button :loading="loading" @click="modal=false;$refs.form.resetFields();">取消</a-button>
        <a-button type="primary" @click="submit" :loading="loading">确定</a-button>
      </a-space>
    </template>
  </a-modal>
</template>

<script>
import { apiPreBatchUpdate } from '@/api/scp/pre-order-and-placement/pre-order-and-placement'
import moment from 'moment';

export default {
  name: 'BatchEditModal',
  props: {
    capacitySufficientList: {
      type: Array,
      default: () => {
        return []
      }
    }
  },
  data() {
    return {
      fieldType: '', // 修改字段标识
      modal: false,
      formData: {
        capacitySufficientIs: "",
        specificProblemDescription: '',
        capacitySolutions: '',
        bottleneckMaterials: '',
        compressPurchaseCycle: '',
        remark: '',
        latestConfirmTime: '',
        supplyStrategyProposal: ''
      },
      loading: false,
      rules: {
        capacitySufficientIs: [{ required: true, message: ' ', trigger: 'change' }],
        specificProblemDescription: [{ required: true, message: ' ', trigger: 'blur' }],
        capacitySolutions: [{ required: true, message: ' ', trigger: 'blur' }],
        bottleneckMaterials: [{ required: true, message: ' ', trigger: 'change' }],
        compressPurchaseCycle: [{ required: true, message: ' ', trigger: 'blur' }],
        remark: [{ required: true, message: ' ', trigger: 'blur' }],
        latestConfirmTime: [{ required: true, message: ' ', trigger: 'change' }],
        supplyStrategyProposal: [{ required: true, message: ' ', trigger: 'blur' }]
      },
      selectedRows: []
    }
  },
  methods: {
    moment,
    show (list, field) {
      this.fieldType = field // 区分修改字段标识
      this.selectedRows = list
      this.formData.capacitySufficientIs = ""
      this.formData.specificProblemDescription = ""
      this.formData.capacitySolutions = ""
      this.formData.bottleneckMaterials = ""
      this.formData.compressPurchaseCycle = ''
      this.formData.latestConfirmTime = ""
      this.formData.remark = ""
      this.formData.supplyStrategyProposal = ""
      this.modal = true
    },
    // 瓶颈物料非必填，特殊处理undefined入参接口会丢失问题
    changeBottleneckMaterial(val, data) {
      if (val === undefined) { data.bottleneckMaterials = '' }
    },
    submit () {
      this.$refs.form.validate(valid => {
        if(valid) {
          const ids = this.selectedRows.map(item => item.id)
          const params = { ids: ids }
          if (this.formData[this.fieldType]) {
            params[this.fieldType] = this.formData[this.fieldType]
          } else {
            this.$message.warning('请检查必填字段')
            return false;
          }
          this.loading = true;
          apiPreBatchUpdate(params).then(response => {
            if (response.code === 200) {
              this.modal = false
              this.$message.success('修改完成!')
              this.$emit("onRefresh")
            } else {
              this.$message.error(response.msg)
            }
          }).finally(() => {
            this.loading = false
          })
        }
      })
    },
    // 选择限制当前和以后日期
    disabledEndDate (date) {
      return date && date.valueOf() < Date.now() - 86400000;
    }
  }
}
</script>

<style scoped>

</style>
